import { generateClampFromMinMax } from '@/utils/styling';
import styled from 'styled-components';

export const NoProjectsFound = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  min-height: ${generateClampFromMinMax(300, 450)};
  border-top: 1px solid var(--c-border);
  grid-column: 1 / -1;

  p {
    animation: fadeIn 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
